// Бага ангийн (1-р анги) эцэг эхийн хуудсуудын нийтлэг: бага ангийн хүүхдүүд, огноо, төслийн карт, хүүхэд сонгогч.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiChevronRight } from "react-icons/fi";
import { instance } from "utils/axios";

export const isElem = (g) => { const n = parseInt(String(g ?? "").match(/\d+/)?.[0] ?? "", 10); return n >= 1 && n <= 5; };
export const md = (d) => (d ? `${Number(String(d).slice(5, 7))}/${Number(String(d).slice(8, 10))}` : "");
export const DAY = ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"];
export const DAY2 = ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"];
export const dow = (d) => new Date(`${d}T00:00:00Z`).getUTCDay();

// Эцэг эхийн хүүхдүүд (/guardian/students) — бага анги эсэхтэй; нэг удаа татна
let cache = null;
export function useKids(enabled = true) {
  const [kids, setKids] = useState(cache);
  useEffect(() => {
    if (cache || !enabled) return;
    instance({ method: "get", url: "/guardian/students" })
      .then((r) => { cache = (r?.data || []).map((s) => ({ ...s, elem: isElem(s.grade) })); setKids(cache); })
      .catch(() => setKids([]));
  }, [enabled]);
  return kids;
}

// Хүүхэд сонгох (олон бага ангийн хүүхэдтэй үед)
export function KidTabs({ kids, value, onChange, dark = false }) {
  if (!kids || kids.length < 2) return null;
  return (
    <div role="tablist" aria-label="Хүүхэд сонгох" className="flex gap-2 overflow-x-auto">
      {kids.map((k) => {
        const on = String(k.id) === String(value);
        return (
          <button key={k.id} type="button" role="tab" aria-selected={on} onClick={() => onChange(k.id)}
            className={`h-9 ${k.imageUrl ? "pl-1 pr-4" : "px-4"} inline-flex items-center gap-2 rounded-full text-sm font-bold whitespace-nowrap shrink-0 transition-colors ${dark
              ? (on ? "bg-white text-primary" : "bg-white/[.12] text-white hover:bg-white/20")
              : (on ? "bg-primary text-white" : "bg-white border border-[#e9e8f0] text-[#1c1c1c] hover:bg-[#faf7ff]")}`}>
            {k.imageUrl && <img src={k.imageUrl} alt="" referrerPolicy="no-referrer" className="h-7 w-7 rounded-full object-cover bg-[#f3eeff]" />}
            {k.firstName}
          </button>
        );
      })}
    </div>
  );
}

export const Avatar = ({ s, size = 56, className = "" }) => {
  const [ok, setOk] = useState(true);
  const src = s?.photo || s?.imageUrl;
  return src && ok
    ? <img src={src} alt="" referrerPolicy="no-referrer" onError={() => setOk(false)} style={{ width: size, height: size }} className={`rounded-full object-cover shrink-0 ${className}`} />
    : <span style={{ width: size, height: size, fontSize: size * 0.42 }} className={`rounded-full bg-[#f2cd30] text-[#3d1b6e] font-extrabold flex items-center justify-center shrink-0 ${className}`}>{(s?.firstName || "?").charAt(0)}</span>;
};

export const SubjectChip = ({ children }) => <span className="inline-flex items-center h-7 px-3 rounded-full bg-[#f3eeff] text-primary text-[13px] font-semibold">{children}</span>;

// "Энэ 7 хоногт … ажиллаж байна" — Хүүхэд хуудасны төслийн карт
export function ProjectCard({ child, project, today }) {
  if (!project) {
    return (
      <section className="tj-card px-4 py-5 md:px-6 text-sm text-[#6e5e8a]">
        Энэ 7 хоногийн төсөл хараахан нийтлэгдээгүй байна.
      </section>
    );
  }
  return (
    <section className="tj-card px-4 py-5 md:p-6 flex flex-wrap gap-5 items-center">
      <div className="flex-[1_1_360px] min-w-0 flex flex-col gap-2">
        <span className="text-[11px] md:text-xs font-bold tracking-[0.12em] uppercase text-[#0e7490]">Энэ 7 хоногт {child.firstName} ажиллаж байна</span>
        <h2 className="m-0 text-xl md:text-2xl font-extrabold leading-tight">{project.no ? `${project.no}-р төсөл · ` : ""}{project.name}</h2>
        {project.goal && <p className="m-0 text-[15px] text-[#6e5e8a] leading-relaxed">{project.goal}</p>}
        {project.subjects?.length > 0 && <div className="flex flex-wrap gap-2 pt-1">{project.subjects.map((s) => <SubjectChip key={s}>{s}</SubjectChip>)}</div>}
      </div>
      <div className="flex-[0_1_300px] w-full flex flex-col gap-3">
        <div className="grid grid-cols-5 gap-1.5">
          {project.days.slice(0, 5).map((d) => (
            <span key={d.date} className={`rounded-xl py-2 flex flex-col items-center text-xs font-bold ${d.date === today ? "bg-primary text-white" : "bg-[#f3eeff] text-[#6e5e8a]"}`}>
              {DAY2[dow(d.date)]}<span className="text-base">{Number(d.date.slice(8, 10))}</span>
            </span>
          ))}
        </div>
        <Link to={`/child/project/${project.id}?c=${child.id}`} className="h-11 rounded-full bg-primary text-white hover:text-white font-bold text-[15px] flex items-center justify-center gap-2">
          Төслийн дэлгэрэнгүй <FiArrowRight />
        </Link>
      </div>
    </section>
  );
}

// Нүүрний hero: мэндчилгээ, хүүхэд, анги, багш нар; баруун талд "Энэ 7 хоногт" төсөл
export function ElemHero({ ov, greet, parentName }) {
  const s = ov.student;
  const p = ov.project;
  return (
    <section className="rounded-[18px] md:rounded-[20px] p-4 md:px-7 md:py-6 text-white flex flex-wrap items-center gap-4 md:gap-6" style={{ background: "#5c1090" }}>
      <Avatar s={s} size={72} />
      <div className="flex-1 min-w-[200px]">
        {greet && <div className="text-[13px] md:text-[15px] text-[#e5d8f5]">{greet}{parentName ? `, ${parentName}` : ""}</div>}
        <div className="text-2xl md:text-[32px] font-extrabold leading-tight">{s.firstName}</div>
        <div className="text-[13px] md:text-[15px] text-[#e5d8f5]">{[`${s.grade}-р анги`, ...ov.teachers.map((t) => `${t.position} ${t.name}`)].join(" · ")}</div>
      </div>
      {p && (
        <Link to={`/child/project/${p.id}?c=${s.id}`} className="w-full md:w-auto md:min-w-[300px] rounded-2xl bg-white/[.12] hover:bg-white/20 px-5 py-4 flex items-center gap-4 text-white hover:text-white">
          <span className="flex-1 min-w-0">
            <span className="block text-[11px] font-bold tracking-[0.12em] uppercase text-[#f2cd30]">Энэ 7 хоногт</span>
            <span className="block text-lg font-extrabold leading-snug">{p.name}</span>
            <span className="block text-[13px] text-[#e5d8f5]">{p.no ? `${p.no}-р төсөл · ` : ""}{md(p.startDate)} – {md(p.endDate)}</span>
          </span>
          <FiChevronRight size={20} />
        </Link>
      )}
    </section>
  );
}

export function useOverview(id) {
  const [ov, setOv] = useState(null);
  useEffect(() => {
    if (!id) return undefined;
    let alive = true;
    setOv(null);
    instance({ method: "get", url: `/student/elem/${id}/overview` }).then((r) => alive && setOv(r.data)).catch(() => alive && setOv(false));
    return () => { alive = false; };
  }, [id]);
  return ov;
}

// Олон хүүхэдтэй эцэг эхийн нүүрт — том hero-ийн оронд жижиг мөр: хүүхэд · энэ 7 хоногийн төсөл
export function ElemWeekStrip({ ov }) {
  const s = ov.student;
  const p = ov.project;
  return (
    <Link to={p ? `/child/project/${p.id}?c=${s.id}` : `/child?c=${s.id}`} className="tj-card px-4 py-3 md:px-5 flex items-center gap-3 text-[#1c1c1c] hover:text-[#1c1c1c] hover:bg-[#faf7ff]">
      <Avatar s={s} size={40} />
      <span className="flex-1 min-w-0">
        <span className="block text-[15px] font-bold">{s.firstName} <span className="font-normal text-[#6e5e8a]">· {s.grade}-р анги</span></span>
        <span className="block text-[13px] text-[#6e5e8a] truncate">{p ? <>Энэ 7 хоногт: <b className="text-primary">{p.name}</b> · {md(p.startDate)} – {md(p.endDate)}</> : "7 хоногийн тайлан, ирц"}</span>
      </span>
      <FiChevronRight className="text-primary shrink-0" size={20} />
    </Link>
  );
}
